import { Product } from '@cabukaka/types'
import { Link } from 'react-router-dom';
import { ProductsList } from '../../shared/products/ProductsList';


interface SimilarProductsProps {
    products: Product[];
    product: Product
}
export default function SimilarProducts({products , product}: SimilarProductsProps) {
  return (
    <div>
          {products.length > 0 && (
                <div className="border-t border-gray-100 bg-white/50 mt-4 md:mt-8">
                    <div className="px-4 md:container md:mx-auto md:px-4 py-6 md:py-12">
                        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-4 md:mb-8 gap-3">
                            <div>
                                <p className="text-xs md:text-sm font-semibold text-orange-500 uppercase tracking-wider mb-1">Suggestions</p>
                                <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-900">Produits similaires</h2>
                                <p className="text-xs md:text-sm text-gray-500 mt-1">Découvrez d'autres articles qui pourraient vous plaire</p>
                            </div>
                            <Link
                                to={`/categories/${product.slug}`}
                                className="flex items-center gap-2 text-orange-600 hover:text-orange-700 font-medium text-sm md:text-base transition-colors group"
                            >
                                Voir tout
                            </Link>
                        </div>
                        
                        <ProductsList
                            layout="horizontal-scroll"
                            products={products}
                            showActionBtn={false}
                            showDescription={false}
                            showRating={false}
                            showReviewsCount={false}
                            showShopName={true}
                            showShopAddress={false}
                        />
                    </div>
                </div>
            )}
    </div>
  )
}
